import {enableProdMode, NgModuleRef, NgZone} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Router } from '@angular/router';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';

import { Injector } from '@angular/core';
import {HybridToolsService} from './app/core/services/hybrid-tools.service';
import {DOCUMENT} from "@angular/common";
import { URLOpenListenerEvent } from '@capacitor/app/dist/esm/definitions';

import { FacebookLogin } from '@capacitor-community/facebook-login';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

const hybridToolsService = Injector.create([{provide: HybridToolsService, deps: []}]).get(HybridToolsService);
const platform = Injector.create([{provide: DOCUMENT, useValue: document, deps: [] }, { provide: NgZone, useFactory: () => new NgZone({}), deps: [] }, {provide: Platform, deps: [DOCUMENT, NgZone]}]).get(Platform);
//

let latestAppModule: NgModuleRef<AppModule>;
let five9Wait;

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => {

    initializeFacebook();
    initializeGoogle();
    initializeF9Chat();

    hybridToolsService.retrieveDeviceInfo().then( () => {
        platformBrowserDynamic().bootstrapModule(AppModule).then((ngModule: NgModuleRef<AppModule>) => {
            latestAppModule = ngModule;
        });
    });
};

function httpGetAsync(theUrl, callback) {
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.onreadystatechange = function() {
        if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
            callback(xmlHttp.responseText);
        }
    }

    xmlHttp.open('GET', theUrl, true); // true for asynchronous
    xmlHttp.send(null);
}

const initialize = (env) => {

    const envUrl = `https://${env}fundraise.lls.org/assets/environment.js`;

    httpGetAsync(envUrl, (data: string) => {
        console.log(data);
        eval(data); //in theory should update ENVIRONMENT_CONFIG

        bootstrap();
    });
}

// Handle Custom Scheme app opener
declare var ENVIRONMENT_CONFIG: any;
declare var $: any;
declare var F9: any;

const navigate = function (url, allowInit) {

    if (url.startsWith('mylls://')) {

        const parser = document.createElement('a');
        parser.href = url;

        if (allowInit) {
            //pathname is only present in android, hostname is only present in iOS
            if (parser.pathname === '//init-env' || parser.hostname === 'init-env') {
                const env = parser.search.split('=')[1];
                initialize(env);
            }
        }

        if (parser.pathname === '//social-login' || parser.hostname === 'social-login') {
            initializeF9Chat();
        }

    } else if (url.startsWith('fb')) {
        // iOS callback when native facebook app is installed
        const queryParams: any = { };

        let url = '/home';
        queryParams.mobileFacebookFundraiser = 1;

        latestAppModule.injector.get(Router).navigate([url], {
            queryParams: queryParams
        });
    } else {
        initialize('');
    }
};

function getQueryVariable(search: string, variable: string) {
    let query = search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    console.log('Query variable %s not found', variable);
}

function initializeF9Chat() {
    initializeAdvancedF9Chat();
}

function initializeAdvancedF9Chat() {

    //do not display F9 Chat within the mobile app until it can be validated.  The old chat did not play nicely with the mobile app
    if (!hybridToolsService.isMobileApp()) {
        // remove old Five9Chat
        $('#five9script').remove();
        (<any>window).F9 = undefined;
        if (five9Wait) {
            clearInterval(five9Wait);
        }

        const f9Script = document.createElement('script');

        f9Script.setAttribute('src', 'https://cdn.prod.us.five9.net/static/stable/chat/wrapper/index.js');
        f9Script.setAttribute('id', 'five9script');

        document.head.appendChild(f9Script);

        five9Wait = setInterval(function () {
            if (window && (window as any).F9) {
                F9.Chat.Wrapper.init({
                    cdn: 'prod',
                    integrationId: '0c5f9b15-2885-4fd2-9bc7-cbdae2b6becf', //this should be static for the organization
                    chatDeploymentId : '24eac7c8-f297-4013-8ebf-077279e016f8' //this may change depending on the application/context
                });

                clearInterval(five9Wait);
            }
        }, 500)
    }

}

function initializeFacebook() {
    FacebookLogin.initialize({
        appId: ENVIRONMENT_CONFIG.facebookAppId,
        version: ENVIRONMENT_CONFIG.facebookGraphApiVersion
    });
}

function initializeGoogle() {
    GoogleAuth.initialize({
      clientId: ENVIRONMENT_CONFIG.googleAppId,
      scopes: ['profile', 'email']
    });
}

function initializeApp() {
    platform.ready().then(async () => {

        if (platform.is('capacitor')) {
            // THIS WILL BE USED IF THE APP IS ALREADY OPEN:
            App.addListener('appUrlOpen', (urlOpen: URLOpenListenerEvent) => {
                console.log('App URL Open', urlOpen);
                console.log(urlOpen);
                navigate(urlOpen.url, false);
            });
        }

        // THIS WILL BE USED IF THE APP HAS BEEN KILLED AND RE-OPENED:
        await getLaunchUrl();
    });
}

async function getLaunchUrl() {
    const urlOpen = await App.getLaunchUrl();
    if (!urlOpen || !urlOpen.url) {
        initialize(''); //empty string will point to prod by default
    } else {
        console.log('Launch URL', urlOpen);
        console.log(urlOpen);
        navigate(urlOpen.url, true);
    }
}

if (hybridToolsService.isMobileApp()) {
    initializeApp();
} else {
    bootstrap();
}

